export default {"src":"/_next/static/media/secure_loan.38f2e4af.svg","height":207,"width":497,"blurWidth":0,"blurHeight":0};